<style scoped>
.rdm-gift {
    @apply px-0 pb-0;
}
</style>

<template>
    <div class="rdm-gift">
        <TimeoutBannerWithGreet
            class="flex-shrink-0 w-full max-w-site mx-auto border-b-2 border-t-0 sm:border-l-2 sm:border-r-2 sm:rounded-b-lg border-secondary"
        >
            <div class="flex mr-2 ml-2 sm:ml-0 sm:mr-6">
                您的結餘: {{ crdtPntBal | numberWithCommas }}
                <div class="icon text-primary">
                    <tryhalaCoinSvg />
                </div>
            </div>
        </TimeoutBannerWithGreet>
        <div class="px-4 pb-16">
            <div class="mt-3">
                <div class="text-secondary">
                    <button
                        class="px-2 focus:outline-none border-r border-secondary"
                        :class="{
                            'text-darkGrayishBlue': activeTab === 'products'
                        }"
                        @click="activeTab = 'products'"
                    >
                        {{ '換領禮品' }}
                    </button>
                    <button
                        class="px-2 focus:outline-none "
                        :class="{
                            'text-darkGrayishBlue': activeTab === 'history'
                        }"
                        @click="activeTab = 'history'"
                    >
                        {{ '換領紀錄' }}
                    </button>
                </div>
            </div>
            <div v-if="activeTab === 'products'">
                <section class="my-4" v-if="rdmGiftProdListBySaleCatg.length">
                    <breadcrumb
                        class="inline-block"
                        :links="[
                            {
                                text: '換領禮品',
                                route: '/rdmGift'
                            },
                            ...(prodCatgDesp ? [{ text: prodCatgDesp }] : [])
                        ]"
                    />
                    <button
                        v-if="showProdCatgFltr === 'Y'"
                        class="ml-4 bg-secondary rounded p-1 pr-2"
                        @click="showProdCatgSlctMenu = true"
                    >
                        <div class="text-white">
                            <div
                                class="inline-block align-bottom fill-current leading-none"
                            >
                                <menuSvg />
                            </div>
                            <span class="text-white">分類</span>
                        </div>
                    </button>

                    <BannerAdvertisement
                        class="mt-2"
                        type="inPage"
                        ref="BannerAdvertisement"
                        :fillImgHeight="true"
                    />
                    <div class="flex flex-wrap -mx-4">
                        <div
                            class="flex justify-center m-3 w-full"
                            v-if="!rdmGiftProdListBySaleCatg.length"
                        >
                            <spinner />
                        </div>
                        <giftProductBlock
                            v-for="(p, pi) in rdmGiftProdListBySaleCatg"
                            :key="pi"
                            :product="p"
                            :productWidthClass="productWidthClass"
                        />
                    </div>
                </section>
                <div v-else class="text-center">
                    <bubble class="mt-4">
                        <template #image>
                            <img :src="bubbleImg" class="w-16 sm:w-20" />
                        </template>
                        <div class="text-lg text-3xl">
                            {{ '換領禮品準備中' }}
                        </div>
                    </bubble>
                </div>
            </div>
            <div v-else-if="activeTab === 'history'">
                <rdmGiftHistory />
            </div>
            <floatingProdCatgSlctMenu
                :showMenu="showProdCatgSlctMenu"
                :prodList="rdmGiftProdList"
                @close="showProdCatgSlctMenu = false"
                @setProdCatgSlctKey="setProdCatgSlctKey"
            />
        </div>
    </div>
</template>

<script>
import TimeoutBannerWithGreet from '../../components/timeoutBannerWithGreet.vue';
import tryhalaCoinSvg from '@/assets/svg/tryhala_coin.svg';
import giftProductBlock from '@/components/giftProductBlock.vue';
import rdmGiftHistory from '@/components/rdmGiftHistory.vue';
import BannerAdvertisement from '../../components/bannerAdvertisement.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import menuSvg from '@/assets/svg/menu.svg';
import floatingProdCatgSlctMenu from '@/components/floatingProductCategorySelectionMenu.vue';
import bubble from '@/components/bubble.vue';
import img8s112 from '@/assets/img/8-112.png';
import numberWithCommas from '@/components/numberWithCommasFilter.js';

export default {
    components: {
        TimeoutBannerWithGreet,
        tryhalaCoinSvg,
        giftProductBlock,
        BannerAdvertisement,
        rdmGiftHistory,
        breadcrumb,
        menuSvg,
        floatingProdCatgSlctMenu,
        bubble
    },
    filters: { numberWithCommas },
    props: {
        productWidthClass: {
            default: 'w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6 '
        }
    },
    async created() {
        this.$store.dispatch('getCreditPointBalance');
    },
    data() {
        return {
            showProdCatgSlctMenu: false,
            prodCatgSlctKey: parseInt(this.$route.params.prodCatgSlctKey),
            bubbleImg: img8s112,
            activeTab: 'products'
        };
    },
    watch: {
        '$route.params.prodCatgSlctKey': {
            handler: function(to) {
                this.$data.prodCatgSlctKey = parseInt(to);
                this.showProdCatgSlctMenu = false;
            }
        }
    },
    computed: {
        crdtPntBal() {
            return this.$store.state.crdtPntBal;
        },
        rdmGiftProdList() {
            const rdmGiftProdList = this.$store.getters.rdmGiftProdList;
            return rdmGiftProdList.filter(p => p.dispProdInd === 'Y');
        },
        showProdCatgFltr() {
            return this.$store.state.showProdCatgFltr;
        },
        rdmGiftProdListBySaleCatg() {
            if (this.prodCatgSlctKey) {
                return this.rdmGiftProdList.filter(
                    p => p.prodCatgSlctKey === this.prodCatgSlctKey
                );
            }
            return this.rdmGiftProdList;
        },
        prodCatgDesp() {
            const prodCatgList = this.$store.state.prodCatgList || [];
            const prodCatg = prodCatgList.filter(
                prodCatg => prodCatg.id === this.prodCatgSlctKey
            );
            return prodCatg.length <= 0
                ? this.prodCatgSlctKey === 0
                    ? '其他'
                    : undefined
                : prodCatg[0].slctDesp;
        }
    },
    methods: {
        setProdCatgSlctKey(prodCatgSlctKey) {
            this.showProdCatgSlctMenu = false;
            if (prodCatgSlctKey !== null && prodCatgSlctKey !== undefined) {
                this.$router.push(`/rdmGift/${prodCatgSlctKey}`);
                this.showProdCatgSlctMenu = false;
            } else {
                this.$router.push('/rdmGift');
            }
        }
    }
};
</script>
